<template lang="html">
	<div class="confirm-email">
		<div class="overlay"></div>

		<div class="area">
			<div class="row justify-content-center">
				<div class="col-11 col-md-9 col-lg-6 col-xl-5">
					<div class="confirm-box">
						<div class="row justify-content-center">
							<div class="col-11 col-sm-10 col-md-9 col-lg-8">
								<div
									class="content"
									v-if="!isConfirmed && !hasError"
								>
									<Form
										classBinding="row line-fields"
										:ref="
											RegisterModel.forms.passwordSetup
												.name
										"
										:forms="
											RegisterModel.forms.passwordSetup
												.forms
										"
										:formData="
											RegisterModel.forms.passwordSetup
												.data
										"
									/>
									<div
										class="btn btn-long"
										@click="
											setUpPassword(
												$refs[
													RegisterModel.forms
														.passwordSetup.name
												],
											)
										"
									>
										Set Up Password
										<div class="lds-ring" v-show="loading">
											<div></div>
											<div></div>
											<div></div>
											<div></div>
										</div>
									</div>
								</div>

								<div
									class="content"
									v-else-if="isConfirmed && !hasError"
								>
									<h4 class="title">Email confirmed</h4>
									<div class="subtitle">
										Email verified successfully
									</div>
									<div class="line"></div>
									<div class="description">
										To get the best out of the system, it's
										good to complete your profile setup.
									</div>
									<div class="link" @click="logIn()">
										LOG IN
									</div>
								</div>

								<div
									class="content"
									v-else-if="!isConfirmed && hasError"
								>
									<h4 class="title">{{ title }}</h4>
									<div class="line"></div>
									<div class="description">
										{{ description }}
									</div>
									<div
										class="btn btn-long"
										v-if="action === 1"
									>
										Refresh Token
									</div>
									<div
										class="btn btn-long"
										v-else-if="action === 2"
										@click="Register()"
									>
										Register Here!
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import register from './rsc/stores/register.store';

export default {
	beforeDestroy() {
		this.$store.unregisterModule('register');
	},
	created() {
		utils.registerModule('register', register, this.$store);
	},
	components: {
		Form: () => import('@/libs/clarks/components/form'),
	},
	computed: {
		...mapGetters([
			'RegisterModel',
			'loading',
			'setUpId',
			'action',
			'title',
			'description',
			'hasError',
			'isConfirmed',
		]),
	},
	methods: {
		...mapActions([
			'setUpPassword',
			'logIn',
			'Register',
			'verifyToken',
			'showPasswordForm',
		]),
	},
	async mounted() {
		utils.registerModule('register', register, this.$store);

		let id = $session.GET('setUpId');
		if ($session.GET('setUpId')) {
			this.$store.commit('setUpId', id);
			this.showPasswordForm();
		} else {
			this.verifyToken(this.$route.query.token);
		}
	},
};
</script>

<style lang="less">
.confirm-email {
	width: 100%;
	min-height: 100vh;
	background: url('/img/img1.jpg') no-repeat;
	background-size: cover;
	background-position: center;
	position: relative;

	.area {
		position: relative;
		z-index: 3;

		.confirm-box {
			border-radius: 8px;
			box-shadow: 0 2px 44px 0 #45495b14;
			background-color: #f7f8fc;
			padding: 70px 0 30px 0;
			margin-top: 100px;

			.btn-long {
				margin-top: 30px;
				width: 100%;
				background: var(--ne-red);
				color: var(--white);
			}
			.link {
				color: var(--ne-blue);
				font-size: 15px;
				margin: 30px 0 0 0;
				font-weight: 600;
			}
			.subtitle {
				margin: 15px 0 0 0;
				font-size: 17px;
				color: #3d4661;
			}
			.line {
				width: 20%;
				border-top: solid 3px #5f2677;
				margin: 15px 0 30px 0;
			}
			.description {
				color: #6b6f81;
				font-size: 15px;
			}
		}
	}
	.overlay {
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background: rgba(0, 60, 128, 0.4);
		z-index: 2;
	}
}
</style>
